class TowBookService {
  /**
      * @param {{
      * postApprovalEventRecordId: number
      * dispatchId: string
      * providerId: string
      * motorClubShortName: string
      * [remarks]: string
      * updateType: string
      * [notes]: string
      * approved: boolean
      * updatedEta: number
      * [responseCode]: string
      * digitalProviderNetwork: string
      * }} values
      * @returns {Object}
    */

  static mapPostApprovalEventResponsePayload({
    postApprovalEventRecordId,
    dispatchId,
    providerId,
    notes,
    approved,
    digitalProviderNetwork
  }) {
    return {
      postApprovalEventRecordId,
      dispatchId,
      providerId,
      notes,
      approved,
      digitalProviderNetwork
    };
  }
}

export default TowBookService;
